import { FilterableField } from 'module/types/filter-field/field/filterable-field';
import { Tag } from 'module/ui/components/atoms/tag';
import { getRenderer as getRendererBase } from 'module/ui/components/molecules/ag-grid-renderer/ag-grid-renderer';
import { ICellRendererParams } from 'ag-grid-community';
import { PeopleListRow } from 'api/account-people/types';
import { Dictionary } from 'lodash';
import { FormattedMessage } from 'react-intl';

interface Props extends ICellRendererParams<PeopleListRow> {
  fieldsLookupByFieldName: Dictionary<FilterableField>;
}

export const GroupRenderer = (props: Props) => {
  const { node, value, fieldsLookupByFieldName } = props;

  if (!value) {
    return (
      <Tag color="gray">
        <FormattedMessage id="none" />
      </Tag>
    );
  }

  if (!node.field) {
    return value;
  }

  const field = fieldsLookupByFieldName[node.field];

  if (!field) {
    return value;
  }

  const renderer = getRendererBase(field);

  return typeof renderer === 'function' ? renderer(props) : value;
};
